import Meta from "../util/Meta";

export class SaldoColaborador {
    static async getSaldo(matricula: string): Promise<ISaldo> {
        return await new Promise((res, rej) => {
            fetch(Meta.get('root') + '/saldo/' + matricula, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    if (res.status === 200) {
                        return res.json() as Promise<ISaldo>;
                    } else if (res.status === 404 || res.status === 400) {
                        throw new Error('Desculpe, mas não foi possível exibir o saldo disponível.');
                    } else {
                        throw new Error(`Erro inesperado: [${res.status}] ${res.statusText}`);
                    }
                })
                .then(res)
                .catch(rej);
        });
    }
}

export interface ISaldo {
    matricula: string;
    limitecredito: number;
    acumulado: number;
    saldo: number;
}
